var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.72743 1.99529C3.93861 0.923649 5.64168 0.333496 7.52393 0.333496C9.36686 0.333496 11.143 1.01275 12.3969 2.19667L12.501 2.2945L12.6049 2.19667C13.8588 1.01275 15.6348 0.333496 17.4776 0.333496C19.3595 0.333496 21.0629 0.923649 22.2741 1.99529C23.434 3.02147 24.1528 4.08723 24.1528 6.22539L24.1524 18.6525H20.7568L20.7562 6.22539C20.7562 4.59114 19.3164 3.3109 17.4774 3.3109C15.639 3.3109 14.1986 4.59099 14.1986 6.22539L14.1983 18.6525H10.8024L10.8018 6.22539C10.8018 4.59114 9.36203 3.3109 7.52348 3.3109C5.68477 3.3109 4.24451 4.59099 4.24451 6.22539L4.2439 18.6525H0.848806L0.847748 6.22539C0.848656 4.08723 1.5675 3.02147 2.72743 1.99529Z",
    fill: "#EC008C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.db0dfcf2afcc4eda4705c395d230d520.svg";
export { ForwardRef as ReactComponent };